import React, { useState, memo, useEffect } from "react";
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const EditUnacceptanceResult = memo((props) => {
  const { init_acceptance_result, removeAcceptanceResult } = props;
  const [currentEditUnaptResult, setCurrentEditUnaptResult] = useState(init_acceptance_result);

  const notify = (type, message) => {
    if (type === "success") {
      toast.success(message, {
        hideProgressBar: true
      });
    } else {
      toast.error(message, {
        hideProgressBar: true
      });
    }
  }

  const onChangeData = (e) => {
    setCurrentEditUnaptResult({
      ...currentEditUnaptResult,
      [e.target.name]: e.target.value,
    })
  };

  const onClinicUnaptResultUpdate = () => {
    if (!currentEditUnaptResult.corporation_id || !currentEditUnaptResult.notes) {
      alert("※全項目が必須選択・入力です。");
      return
    }

    var data = {
      acceptance_result: {
        notes: currentEditUnaptResult.notes,
      },
      id: currentEditUnaptResult.id,
    }

    // axios csrfToken
    const csrfToken = document.querySelector('[name=csrf-token]').content
    axios.defaults.headers.common['X-CSRF-Token'] = csrfToken

    axios.patch(`/api/v1/acceptance_results/${currentEditUnaptResult.id}`, data)
    .then(resp => {
      console.log(resp.data);
      notify("success", "UnacceptanceResult successfully updated!");
    })
    .catch(e => {
      console.log(e.response);
      setCurrentEditUnaptResult({ 
        ...currentEditUnaptResult,
        notes: init_acceptance_result.notes,
      });
      alert(JSON.parse(e.request.responseText).errors);
      notify("error", "UnacceptanceResult updated Error!");
    })
  }

  const onClickDeleteSubmit = (id) => {
    const sure = window.confirm('Are you sure?');
    if (sure) {
      // axios csrfToken
      const csrfToken = document.querySelector('[name=csrf-token]').content
      axios.defaults.headers.common['X-CSRF-Token'] = csrfToken

      axios.delete(`/api/v1/acceptance_results/${id}`)
      .then(resp => {
        console.log(resp);
        removeAcceptanceResult(id);
        notify("success", "AcceptanceResult successfully deleted!");
      })
      .catch(e => {
        console.log(e.response);
        notify("error", "AcceptanceResult delete Error!");
      })
    }
  }

  return (
    <>
      <tr>
        <th scope="row" className="col">{currentEditUnaptResult.corporation_name}</th>
        <td className="col-6">
          <div className="input-group">
            <span className="input-group-text">理由</span>
            <textarea type="text" name="notes" className="form-control basic-unable-notes" cols="30" rows="1" placeholder="理由内容を入力※必須" value={currentEditUnaptResult.notes} onChange={onChangeData}></textarea>
          </div>
        </td>
        <td className="col-2">
          <button className="btn btn-success mr-1" onClick={onClinicUnaptResultUpdate} disabled={(!currentEditUnaptResult.corporation_id || !currentEditUnaptResult.notes)}>
            <i className="fa fa-share-square" />
          </button>
          <button className="btn btn-outline-danger" onClick={() => onClickDeleteSubmit(currentEditUnaptResult.id)}>
            <i className="far fa-trash-alt" />
          </button>
        </td>
      </tr>
    </>
  );
});